import * as React from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';

import { useOrganixContext } from './IOrganixContext';

interface IProps {
  canvas: HTMLCanvasElement;
}

const OrganixMap = (props: IProps) => {
  const ctx = useOrganixContext();

  return (
    <Source 
      type="canvas" 
      canvas={props.canvas}
      animate
      coordinates={[
        [ctx.simulation.area.rect.minLng, ctx.simulation.area.rect.minLat],
        [ctx.simulation.area.rect.maxLng, ctx.simulation.area.rect.minLat],
        [ctx.simulation.area.rect.maxLng, ctx.simulation.area.rect.maxLat],
        [ctx.simulation.area.rect.minLng, ctx.simulation.area.rect.maxLat]
      ]}
    >
      <Layer type="raster"/>
    </Source>
  )
}

export { OrganixMap }
